import React from "react";
import {
  Timeline,
  TimelineHeader,
  TimelineTitle,
  TimelineSubtitle,
  TimelineMain,
  TimelineSteps,
  TimelineFooter,
} from "raffle-house-uikit";
import "./styles.css";

const TimelineBlock = (props) => {
  const { content } = props;
  return (
    <Timeline>
      <TimelineHeader badgeText={content.specialBadge}>
        <TimelineTitle>{content.title}</TimelineTitle>
        <TimelineSubtitle>{content.description}</TimelineSubtitle>
      </TimelineHeader>
      <TimelineMain>
        <TimelineSteps steps={content.stepper} />
        {content.footerText && <TimelineFooter>{content.footerText}</TimelineFooter>}
      </TimelineMain>
    </Timeline>
  );
};

export default TimelineBlock;
